/**
 * Partition for AWS Usage (ADJUSTMENT) service scope UI.
 * UI state: one `selectedServices` + `scopeOperatorServices` (applies to eligible only).
 * API: eligible service scopes use scope_type `SERVICE`; ineligible use `INELIGIBLE_SERVICE`.
 * Ineligible scopes always send `operator: INCLUDE`; eligible use `scopeOperatorServices`.
 * Ineligible codes come from customer metadata `kind: "ineligible_service_codes"`.
 */

/** Payload `scope_type` for AWS Usage ineligible service codes (eligible uses SERVICE). */
export const BILLING_SCOPE_TYPE_INELIGIBLE_SERVICE = "INELIGIBLE_SERVICE";

/** Normalize metadata list responses (service_codes, ineligible_service_codes, etc.). */
export function normalizeMetadataCodeList(responseData) {
  if (!responseData || typeof responseData !== "object") return [];
  const list =
    responseData.values ??
    responseData.service_codes ??
    responseData.ineligible_service_codes ??
    [];
  return Array.isArray(list) ? list : [];
}

/**
 * @param {unknown} serviceCodes - full catalog from `service_codes` metadata
 * @param {Set<string>} ineligibleSet - codes from `ineligible_service_codes` metadata
 */
export function getEligibleServiceCodesFromApi(serviceCodes, ineligibleSet) {
  const set = ineligibleSet instanceof Set ? ineligibleSet : new Set();
  if (!Array.isArray(serviceCodes)) return [];
  return serviceCodes.filter((s) => !set.has(s));
}

/**
 * @param {unknown} selectedServices
 * @param {Set<string>} ineligibleSet
 */
export function partitionSelectedServicesForAwsUsage(selectedServices, ineligibleSet) {
  const set = ineligibleSet instanceof Set ? ineligibleSet : new Set();
  if (!Array.isArray(selectedServices)) return { eligible: [], ineligible: [] };
  const eligible = [];
  const ineligible = [];
  for (const s of selectedServices) {
    if (set.has(s)) ineligible.push(s);
    else eligible.push(s);
  }
  return { eligible, ineligible };
}
